export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const ADMIN_SERVICE_USER = process.env.REACT_APP_ADMIN_SERVICE_USER || '';

export const TOOLS_URL = `${API_BASE_URL}/tools`;
export const AGENTS_URL = `${API_BASE_URL}/agents`;
export const PLAYBOOKS_URL = `${API_BASE_URL}/playbooks`;
export const PROMPTS_URL = `${API_BASE_URL}/prompts`;
export const ANNOTATION_URL = `${API_BASE_URL}/annotation`;
export const ADMIN_URL = `${API_BASE_URL}/admin`;
export const USERS_URL = `${API_BASE_URL}/users`;
export const SYSTEM_INFO_URL = `${API_BASE_URL}/system-info`;
export const PRODUCTS_URL = `${API_BASE_URL}/products`;
export const TAGS_URL = `${API_BASE_URL}/tags`;
export const ADAPTERS_URL = `${API_BASE_URL}/adapters`;
export const ADAPTER_URL = `${API_BASE_URL}/adapter`;

export const WEBHOOKS_URL = `${API_BASE_URL}/webhooks`;

export const DEFAULT_TOOL_TIMEOUT = '90'; // seconds ; TODO: Move this to a different file